import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    let self = this,
    $body = $('body'),
    $burger = $('.burger')

    /* Burger */
    let scrollTopBefore = 0, burgerTimeout = undefined
    self.burger = new Burger('.burger', {
      onToggle: function() {
        if (self.burger.isExpanded) {
          $body.addClass('--mobile-menu-open')
        } else {
          $body.removeClass('--mobile-menu-open')
        }
      },
    })

    /* Responsive toggler */
    $.mlmi.mobile.addCallbacks(function() {
      /* Mobile */
      requestAnimationFrame(function() {
        $body.removeClass('--mobile-menu-open')
        self.burger.maybe_close()
      })
    }, function() {
      /* Desktop */
      requestAnimationFrame(function() {
        $body.removeClass('--mobile-menu-open')
        self.burger.maybe_close()
      })
    })
  },
}
